const calculatorValues = {
  product: '',
  dailyUse: '',
  day: ''
}
const previewLoadingDelay = 2000 

function areAllFieldsFilled() {
  const allFilled = Object.keys(calculatorValues).every((key) => calculatorValues[key] !== '')
  if (!allFilled) return
  
  $('.button-start-calculate').removeClass('disabled')
}

$('select[data-capacity-calculator-selectize]').selectize({
  allowEmptyOption: true,
  placeholder: 'Select a label',
  onChange: function (value) {
    if(!value) return
    calculatorValues.product = value
    areAllFieldsFilled()
  },
  onDropdownOpen: function() {
    this.$control_input
      .focus()
      .blur()
      .prop('readonly', true)
      .on('mousedown', function() {
        $(this).prop('readonly', false);
      });
  },
});

$('.daily_use .variants').click(function() {
  $('.daily_use .variants').removeClass('active')
  $(this).addClass('active')
  calculatorValues.dailyUse = $(this).attr('data-value')
  areAllFieldsFilled()
})

$('.day .variants').click(function() {
  $('.day .variants').removeClass('active')
  $(this).addClass('active')
  calculatorValues.day = $(this).attr('data-value')
  areAllFieldsFilled()
})

$('.button-start-calculate').click(function() {
  if ($('.button-start-calculate').hasClass('disabled')) return
  $('.capacity-calculator-right').addClass('active')
  $('.capacity-calculator-right .placeholder').hide()
  const product = capacityCalculatorData[calculatorValues.product][calculatorValues.dailyUse][calculatorValues.day].product
  const description = capacityCalculatorData[calculatorValues.product][calculatorValues.dailyUse][calculatorValues.day].text

  $('.size-item').removeClass('active')
  $('.page-width').animate({
    scrollTop: $('.capacity-calculator-right').offset().top
  }, 300);

  $('.capacity-calculator-right').addClass('loading').delay(previewLoadingDelay).queue((next) => {
    $('.capacity-calculator-right').removeClass('loading')
    $(`[data-size="${product}"]`).addClass('active')
    $(`[data-size="${product}"] .description`).html(description)
    next()
  });
})